/* $(document).ready(function () {
	const VerticalMenu = {
		menuJson: null,
		assetsUrl: null,

		init: function () {
			const _this = this;

			this.loadAssetsUrl();
			this.loadMenuFromMetafield(function () {
				_this.setEvents();
			});
		},

		loadAssetsUrl: function() {
			this.assetsUrl = $('.vertical-menu-overlay').data('assets-url');
			this.assetsUrl = this.assetsUrl.substring(0, this.assetsUrl.lastIndexOf('/')) + '/';
		},

		loadMenuFromMetafield: async function (callback) {
			const _this = this;
			const client = this.getStorefrontApiClient();
			const query = this.getMetafieldGraphqlQuery();

			client.request(query).then(
				function (data) {
					try {
						const rawMenuJson = JSON.parse(data.data.shop.metafield.value);
						_this.transformMenuJson(rawMenuJson);
						_this.updateWindowGlobal();

						if (typeof callback === 'function') {
							callback();
						}
					} catch (error) {
						throw Error('Vertical menu: ' + error);
					}
				},
				function (error) {
					throw Error('Vertical menu: ' + error);
				}
			);
		},

		getStorefrontApiClient: function () {
			if (typeof ShopifyStorefrontAPIClient !== 'undefined') {
				return ShopifyStorefrontAPIClient.createStorefrontApiClient({
					storeDomain: 'farmaciasdirect-es.myshopify.com',
					apiVersion: '2024-07',
					publicAccessToken: 'f2d1b4090bb4f71ee7072b525b3fbce4'
				});
			} else {
				throw Error('Vertical menu: ShopifyStorefrontAPIClient is not defined!');
			}
		},

		getMetafieldGraphqlQuery: function () {
			return `{
						shop {
							metafield(namespace: "farmaciasdirect", key: "vertical_menu") {
								value
							}
						}
					}`;
		},

		transformMenuJson: function (rawMenuJson) {
			this.menuJson = {};

			for (const [key, value] of Object.entries(rawMenuJson)) {
				if (!(value.id in this.menuJson)) {
					this.menuJson[value.id] = [];
				}

				this.iterateChildren(value);
			}
		},

		iterateChildren: function (item) {
			if (item.children.length > 0) {
				if (!(item.id in this.menuJson)) {
					this.menuJson[item.id] = [];
				}

				for (const [key, child] of Object.entries(item.children)) {
					this.menuJson[item.id].push({
						code: child.code,
						handle: child.handle,
						id: child.id,
						level: child.level,
						name: child.name
					});

					this.iterateChildren(child);
				}
			}
		},

		updateWindowGlobal: function () {
			window.menuJson = this.menuJson;
		},

		setEvents: function () {
			const _this = this;

			$('.vertical-menu > .list-menu__link').on('click', function () {
				$(this).closest('.list-menu__item').addClass('active');
				$('.vertical-menu-overlay').addClass('active');
			});

			$('.vertical-menu .next-button').on('click', function () {
				_this.buildSubmenuIfNotExists($(this));
				$('.list-submenu__item').removeClass('active');
				$(this).parents('.list-submenu__item').addClass('active');
			});

			$('.vertical-menu .back-button').on('click', function () {
				$(this).closest('.header__submenu').closest('.list-submenu__item').removeClass('active');
			})

			// Si se hace click fuera del menu cierra todo
			$(document).on('click', function (e) {
				if (!$(e.target).closest('.vertical-menu').length) {
					$('.vertical-menu.list-menu__item, .vertical-menu .list-submenu__item').removeClass('active');
					$('.vertical-menu-overlay').removeClass('active');
				}
			});

			// Si se hace hover en otro menu con hijos cierra todo
			$('.list-menu__link.with-children').on('mouseenter', function () {
				$('.vertical-menu.list-menu__item, .vertical-menu .list-submenu__item').removeClass('active');
				$('.vertical-menu-overlay').removeClass('active');
			});
		},

		buildSubmenuIfNotExists: function (parentButton) {
			const _this = this;
			const parentId = parentButton.data('id');
			const parentName = parentButton.data('name');
			const parentHandle = parentButton.data('handle');
			const parentLevel = parentButton.data('level');

			if (
				$('#submenu_' + parentId).length === 0 &&
				parentId in this.menuJson
			) {
				const submenu = this.menuJson[parentId];

				const ul = $('<ul>').addClass('header__submenu header__submenu--level' + (parentLevel + 1) + ' gradient motion-reduce').attr('id', 'submenu_' + parentId);
				const div = $('<div>').addClass('header__submenu--overflow');
				const li = $('<li>').addClass('list-submenu__item link-back');
				const button = $('<button>').addClass('back-button');
				const img = $('<img>').attr('src', this.assetsUrl + 'vertical_menu_icon_back.svg');
				const a = $('<a>').addClass('list-submenu__link').attr('href', '/collections/' + parentHandle).html(parentName);

				button.on('click', function () {
					$(this).closest('.header__submenu').closest('.list-submenu__item').removeClass('active');
				});

				ul.append(div.append(li.append(button.append(img)).append(a)));

				for (const [key, child] of Object.entries(submenu)) {
					const liChild = $('<li>').addClass('list-submenu__item');
					const aChild = $('<a>').addClass('list-submenu__link').attr('href', '/collections/' + child.handle).html(child.name);

					if (child.id in this.menuJson) {
						const buttonChild = $('<button>').addClass('next-button').attr('data-id', child.id).attr('data-name', child.name).attr('data-handle', child.handle).attr('data-level', (parentLevel + 1));
						const imgChild = $('<img>').attr('src', this.assetsUrl + 'vertical_menu_icon_open_submenu.svg');

						buttonChild.on('click', function () {
							_this.buildSubmenuIfNotExists($(this));
							$('.list-submenu__item').removeClass('active');
							$(this).parents('.list-submenu__item').addClass('active');
						});

						div.append(liChild.append(aChild).append(buttonChild.append(imgChild)));
					} else {
						div.append(liChild.append(aChild));
					}
				}

				ul.insertAfter(parentButton);
			}
		},
	}

	VerticalMenu.init()
}); */

document.addEventListener('DOMContentLoaded', function () {
	const VerticalMenu = {
		menuJson: null,
		assetsUrl: null,
		init: function () {
			this.loadAssetsUrl();
			this.loadMenuFromMetafield(() => {
				this.setEvents();
			});
		},
		loadAssetsUrl: function() {
			this.assetsUrl = document.querySelector('.vertical-menu-overlay').getAttribute('data-assets-url');
			this.assetsUrl = this.assetsUrl.substring(0, this.assetsUrl.lastIndexOf('/')) + '/';
		},
		loadMenuFromMetafield: async function (callback) {
			const client = this.getStorefrontApiClient();
			const query = this.getMetafieldGraphqlQuery();
			try {
				const data = await client.request(query);
				const rawMenuJson = JSON.parse(data.data.shop.metafield.value);
				this.transformMenuJson(rawMenuJson);
				this.updateWindowGlobal();
				if (typeof callback === 'function') {
					callback();
				}
			} catch (error) {
				throw Error('Vertical menu: ' + error);
			}
		},
		getStorefrontApiClient: function () {
			if (typeof ShopifyStorefrontAPIClient !== 'undefined') {
				return ShopifyStorefrontAPIClient.createStorefrontApiClient({
					storeDomain: 'farmaciasdirect-es.myshopify.com',
					apiVersion: '2024-07',
					publicAccessToken: 'f2d1b4090bb4f71ee7072b525b3fbce4'
				});
			} else {
				throw Error('Vertical menu: ShopifyStorefrontAPIClient is not defined!');
			}
		},
		getMetafieldGraphqlQuery: function () {
			return `{
						shop {
							metafield(namespace: "farmaciasdirect", key: "vertical_menu") {
								value
							}
						}
					}`;
		},
		transformMenuJson: function (rawMenuJson) {
			this.menuJson = {};
			for (const value of Object.values(rawMenuJson)) {
				if (!(value.id in this.menuJson)) {
					this.menuJson[value.id] = [];
				}
				this.iterateChildren(value);
			}
		},
		iterateChildren: function (item) {
			if (item.children.length > 0) {
				if (!(item.id in this.menuJson)) {
					this.menuJson[item.id] = [];
				}
				for (const child of Object.values(item.children)) {
					this.menuJson[item.id].push({
						code: child.code,
						handle: child.handle,
						id: child.id,
						level: child.level,
						name: child.name
					});
					this.iterateChildren(child);
				}
			}
		},
		updateWindowGlobal: function () {
			window.menuJson = this.menuJson;
		},
		setEvents: function () {
			document.querySelectorAll('.vertical-menu > .list-menu__link').forEach(link => {
				link.addEventListener('click', function () {
					this.closest('.list-menu__item').classList.add('active');
					document.querySelector('.vertical-menu-overlay').classList.add('active');
				});
			});
			document.querySelectorAll('.vertical-menu .next-button').forEach(button => {
				button.addEventListener('click', () => {
					this.buildSubmenuIfNotExists(button);
					this.removeActiveSiblings(button);
					button.closest('.list-submenu__item').classList.add('active');
				});
			});
			document.querySelectorAll('.vertical-menu .back-button').forEach(button => {
				button.addEventListener('click', function () {
					this.closest('.header__submenu').closest('.list-submenu__item').classList.remove('active');
				});
			});
			// Si se hace click fuera del menu cierra todo
			document.addEventListener('click', function (e) {
				if (!e.target.closest('.vertical-menu')) {
					document.querySelectorAll('.vertical-menu.list-menu__item, .vertical-menu .list-submenu__item').forEach(item => item.classList.remove('active'));
					document.querySelector('.vertical-menu-overlay').classList.remove('active');
				}
			});
			// Si se hace hover en otro menu con hijos cierra todo
			document.querySelectorAll('.list-menu__link.with-children').forEach(link => {
				link.addEventListener('mouseenter', function () {
					document.querySelectorAll('.vertical-menu.list-menu__item, .vertical-menu .list-submenu__item').forEach(item => item.classList.remove('active'));
					document.querySelector('.vertical-menu-overlay').classList.remove('active');
				});
			});
		},
		removeActiveSiblings: function (button) {
			const parentSubmenu = button.closest('.header__submenu');
			parentSubmenu.querySelectorAll('.list-submenu__item').forEach(sibling => {
				sibling.classList.remove('active');
			});
		},
		buildSubmenuIfNotExists: function (parentButton) {
			const parentId = parentButton.getAttribute('data-id');
			const parentName = parentButton.getAttribute('data-name');
			const parentHandle = parentButton.getAttribute('data-handle');
			const parentLevel = parseInt(parentButton.getAttribute('data-level'), 10);
			if (!document.getElementById('submenu_' + parentId) && parentId in this.menuJson) {
				const submenu = this.menuJson[parentId];
				const ul = document.createElement('ul');
				ul.classList.add('header__submenu', 'header__submenu--level' + (parentLevel + 1), 'gradient', 'motion-reduce');
				ul.id = 'submenu_' + parentId;
				const div = document.createElement('div');
				div.classList.add('header__submenu--overflow');
				const li = document.createElement('li');
				li.classList.add('list-submenu__item', 'link-back');
				const button = document.createElement('button');
				button.classList.add('back-button');
				const img = document.createElement('img');
				img.src = this.assetsUrl + 'vertical_menu_icon_back.svg';
				const a = document.createElement('a');
				a.classList.add('list-submenu__link');
				a.href = '/collections/' + parentHandle;
				a.innerHTML = parentName;
				button.addEventListener('click', function () {
					this.closest('.header__submenu').closest('.list-submenu__item').classList.remove('active');
				});
				li.appendChild(button);
				button.appendChild(img);
				li.appendChild(a);
				div.appendChild(li);
				ul.appendChild(div);
				submenu.forEach(child => {
					const liChild = document.createElement('li');
					liChild.classList.add('list-submenu__item');
					const aChild = document.createElement('a');
					aChild.classList.add('list-submenu__link');
					aChild.href = '/collections/' + child.handle;
					aChild.innerHTML = child.name;
					if (child.id in this.menuJson) {
						const buttonChild = document.createElement('button');
						buttonChild.classList.add('next-button');
						buttonChild.setAttribute('data-id', child.id);
						buttonChild.setAttribute('data-name', child.name);
						buttonChild.setAttribute('data-handle', child.handle);
						buttonChild.setAttribute('data-level', parentLevel + 1);
						const imgChild = document.createElement('img');
						imgChild.src = this.assetsUrl + 'vertical_menu_icon_open_submenu.svg';
						buttonChild.addEventListener('click', () => {
							this.buildSubmenuIfNotExists(buttonChild);
							this.removeActiveSiblings(buttonChild);
							buttonChild.closest('.list-submenu__item').classList.add('active');
						});
						liChild.appendChild(aChild);
						liChild.appendChild(buttonChild);
						buttonChild.appendChild(imgChild);
					} else {
						liChild.appendChild(aChild);
					}
					div.appendChild(liChild);
				});
				parentButton.after(ul);
			}
		}
	}
	VerticalMenu.init();
});